import upload from "../../assets/upload.svg";
import cancel from "../../assets/cancelUpload.svg";
import photoDrop from "../../assets/photoDrop.svg";
import formInputs from "../formInputs";
import countries from "../countries.js";
import {
  Select,
  MenuItem,
  OutlinedInput,
  TextField,
  Box,
  Autocomplete,
  // onUpload,
} from "@mui/material/";
import ImageUploading from "react-images-uploading";

const Goals = ({
  // image,
  onUpload,
  handleUserChange,
  userData,
}) => {
  return (
    <div className="goals">
      {userData.mentorType === "Mentor" ? (
        <>
             <p>Select your primary role</p>
          <Select
            required
            name="expertise"
            className="profession"
            labelId="profession"
            value={userData.expertise}
            onChange={handleUserChange}
            input={<OutlinedInput label="Name" />}
          >
            {formInputs.expertise.map((item) => (
              <MenuItem name="expertise" key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        
          <div className="photoUpload">
            <ImageUploading
              name="image"
              value={userData.image}
              onChange={onUpload}
              maxNumber={1}
              dataURLKey="data_url"
            >
              {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
              }) => (
                // write your building UI
                <div className="upload">
                  {userData.image.map((image, index) => (
                    <div key={index} className="userImage">
                      <span onClick={onImageUpdate} className="image">
                        <img
                          src={image["data_url"]}
                          alt="your profile picture"
                        />
                      </span>
                      {/* <span className="remove" onClick={onImageRemoveAll}>
                        <img src={cancel} alt="remove a user icon" />
                      </span> */}
                    </div>
                  ))}
                  {userData.image.length === 0 ? (
                    <span className="emptyUpload" onClick={onImageUpload}>
                      <img src={photoDrop} alt="add a user icon" />
                    </span>
                  ) : null}
                </div>
              )}
            </ImageUploading>
            <p className="uploadText">Upload a photo</p>
          </div>

          <p>Your bio</p>
          <TextField
            className="bio"
            name="bio"
            // label="Your bio"
            onChange={handleUserChange}
            value={userData.bio}
            multiline
            rows={4}
            variant="outlined"
          />

          <p>Your employer:</p>
          <TextField
            name="company"
            required
            // timeZoneArray
            value={userData.company}
            onChange={handleUserChange}
          />

          <p>Your main mentorship services:</p>
          <Select
            required
            // fullWidth
            name="goalsOptions"
            exclusive
            className="mentorGoal"
            labelId="mentorGoal"
            value={userData.goalsOptions}
            onChange={handleUserChange}
            input={<OutlinedInput label="mentorGoal" />}
          >
            {formInputs.goals.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>I'd like to connect with someone who identifies as:</p>
          <Select
            // placeholder="Profession"
            required
            exclusive
            name="connectType"
            className="profession"
            value={userData.connectType}
            onChange={handleUserChange}
            input={<OutlinedInput label="Name" />}
          >
            {formInputs.connection.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>I'd like to connect with someone who went to a bootcamp:</p>
          <Select
            required
            exclusive
            name="bootcamp"
            className="bootcamp"
            labelId="bootcamp"
            value={userData.bootcamp}
            onChange={handleUserChange}
            input={<OutlinedInput label="bootcamp" />}
          >
            {formInputs.bootStatus.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>Experience level:</p>

          <Select 
            required
            name="experienceOptions"
            exclusive
            className="experience"
            labelId="experience"
            value={userData.experienceOptions}
            onChange={handleUserChange}
            input={<OutlinedInput label="Experience" />}
          >
            {formInputs.experience.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>Skills:</p>
          <Select
            required
            multiple
            name="skillsOptions"
            // className="skillsPreference"
            value={userData.skillsOptions}
            onChange={handleUserChange}
            input={<OutlinedInput label="Experience" />}
          >
            {formInputs.skills.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </>
      ) : (
        <>
          {/* Mentee form below here */}

          <p>Select your primary role</p>
          <Select
            required
            name="expertise"
            className="profession"
            labelId="profession"
            value={userData.expertise}
            onChange={handleUserChange}
            input={<OutlinedInput label="Name" />}
          >
            {formInputs.expertise.map((item) => (
              <MenuItem name="expertise" key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          

          <p>Main mentorship goal:</p>
          <Select
            required
            name="goalsOptions"
            exclusive
            className="mentorGoal"
            labelId="mentorGoal"
            value={userData.goalsOptions}
            onChange={handleUserChange}
            input={<OutlinedInput label="mentorGoal" />}
          >
            {formInputs.goals.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>I'd like to connect with someone who identifies as:</p>
          <Select
            // placeholder="Profession"
            required
            exclusive
            name="connectType"
            className="profession"
            value={userData.connectType}
            onChange={handleUserChange}
            input={<OutlinedInput label="Name" />}
          >
            {formInputs.connection.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>I'd like to connect with someone who went to a bootcamp:</p>
          <Select
            required
            exclusive
            name="bootcamp"
            className="bootcamp"
            labelId="bootcamp"
            value={userData.bootcamp}
            onChange={handleUserChange}
            input={<OutlinedInput label="bootcamp" />}
          >
            {formInputs.bootStatus.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>I'd like to connect with someone with this experience level:</p>
          <Select
            required
            name="experienceOptions"
            exclusive
            className="experience"
            labelId="experience"
            value={userData.experienceOptions}
            onChange={handleUserChange}
            input={<OutlinedInput label="Experience" />}
          >
            {formInputs.experience.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>I'd like to connect with someone with these skills:</p>
          <Select
            required
            multiple
            name="skillsOptions"
            // className="skillsPreference"
            value={userData.skillsOptions}
            onChange={handleUserChange}
            input={<OutlinedInput label="Experience" />}
          >
            {formInputs.skills.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </>
      )}
    </div>
  );
};

export default Goals;
